import AccountHome from 'features/accounts/pages/AccountHome/AccountHome';

export default AccountHome;
